import React from 'react';
import { useEffect } from "react";
import { Helmet } from 'react-helmet';
import Form from './Form.js'
import ContentWithImages from './ContentWithImages.js'
import DoctorBite from '../DoctorBite.js';
import PatientReviews from '../PatientReview.js';
import Counter from '../../NumCounter.js'
import GetInTouch from '../GetInTouch.js';
import FollowYt from '../FollowYt.js'
import Breadcrumb from '../Breadcrum.js';

export default function Index() {
  useEffect(() => {
    const metaTags = document.getElementsByTagName('meta');
    Array.from(metaTags).forEach((tag) => {
      console.log(tag);
    });
  }, []);
  return (
    <div>
          <Helmet>
            <title>Best Ear Doctor in Delhi, India | Treatment, Cost, Clinic</title>
            <meta name="description" content="Consult top Ear Doctors in Delhi, India. Get treatment for hearing loss, ear infections, tinnitus, and other ENT conditions at MedFirst ENT Centre." />
            <meta name="keywords" content="Ear doctor Delhi, ENT ear specialist, ear clinic Delhi, Ear Doctor Near me. Ear Doctor Near Me Delhi" />
            <link rel="canonical" href="https://entdelhi.com/ear-doctor-delhi/" />
            <meta property="og:title" content="Best Ear Doctor in Delhi, India | Treatment, Cost, Clinic" />
            <meta property="og:description" content="Consult top Ear Doctors in Delhi, India. Get treatment for hearing loss, ear infections, tinnitus, and other ENT conditions at MedFirst ENT Centre." />
            <meta name="robots" content="index, follow" />
            {/* You can add more meta tags as needed */}
          </Helmet>
      <main>
        <Breadcrumb/>
        <Form />  
        <Counter/>
         <ContentWithImages/>
         <FollowYt/>
         <DoctorBite/>
         <PatientReviews/>
         
         <GetInTouch/>
      </main>
    </div>
  )
}
